import $ from 'jquery';
import { getState } from '~src/state';
import {
  getUser,
  isLoggedUserGlobalEditor,
  isLoggedUserSuperUser,
} from '~src/user';
import {
  aggiungiServizioBlock,
  cambiaServizioBlock,
  colSizes,
  disableLoaderInput,
  displayLoadingContainer,
  doesSelectedProjectRequireFuneral,
  enableLoaderInput,
  initNewServizioForm,
  scegliServizioBlock,
  showContainer,
  hideContainer,
  setServizio,
} from '~loader/loader-utils';
import {
  fetchEditorProjectTypes,
  fetchProjectFormats,
} from '~loader/loader-api';
import {
  templateAddFormats,
  templateAddProjects,
  templateAddHelp,
} from '~loader/loader-template';
import {
  readFormatoFromQueryString,
  readTipoFromQueryString,
  checkShouldCreateCanvas,
} from '~loader/loader-utils/query-string';
import { subscribeObservables } from '../observables/subscribe';
import { initPlayYouTubeModal } from '~src/help';
import isMobile from 'is-mobile';
import { fetchProjectFormatsDefault } from '~src/sidebar/index';
import { RecentProjects } from '~src/components/Projects';
import { RecentTemplates } from '~src/components/Templates';
import ReactDOM from 'react-dom';
import React from 'react';
import {
  fetchFuneralServiceById,
  countFuneralServices,
  fetchConvertedTemplatesCount,
} from '~graphql/controllers';
import { createEditorCanvas } from '~loader/loader-event-handlers';
import { FEATURES, isFeatureEnabled } from '../features';
/**
 * Render Loader
 */
export const renderLoader = async () => {
  displayLoadingContainer('formats', 'regular', 6, false);
  await subscribeObservables();
  const { user } = await getUser();
  const isUserInDemo = user.org_pointer.tipo_istanza === 'demo';
  disableLoaderInput();

  $('#editor-main-menu').show();

  if (user.org_pointer.tipo_istanza === 'demo') {
    showContainer('help');
    templateAddHelp();
  }

  hideContainer('info-mobile-device');
  if (isMobile() && isUserInDemo) {
    showContainer('info-mobile-device');
    return enableLoaderInput();
  }

  showContainer('projects');
  displayLoadingContainer('projects', 'regular', 12, false);

  const { projects } = await fetchEditorProjectTypes();
  Object.assign(window.editorLoader, { projects });

  const isSelectedProjectType = readTipoFromQueryString(projects);
  await templateAddProjects();
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const isSuperUser = await isLoggedUserSuperUser();

  // Show the Publisher import section only if the feature is enabled.
  // Pick the empty or populated sub-block based on how many templates
  // have already been converted for this org.
  const canCreateTemplateFromImport = await isFeatureEnabled(
    FEATURES.CREATE_TEMPLATE_FROM_IMPORT
  );
  if (canCreateTemplateFromImport) {
    const convertedCount = await fetchConvertedTemplatesCount(
      user.org_pointer.objectId
    );
    const emptyEl = document.querySelector('.publisher-import-empty');
    const populatedEl = document.querySelector('.publisher-import-populated');
    if (emptyEl && populatedEl) {
      if (convertedCount >= 1) {
        const countEl = populatedEl.querySelector('.publisher-import-count');
        if (countEl) countEl.textContent = String(convertedCount);
        populatedEl.hidden = false;
        emptyEl.hidden = true;
      } else {
        emptyEl.hidden = false;
        populatedEl.hidden = true;
      }
      showContainer('import-publisher');
    } else if (process.env.NODE_ENV !== 'production') {
      console.warn(
        'renderLoader: publisher-import sub-blocks not found in DOM — check loader.html'
      );
    }
  } else {
    hideContainer('import-publisher');
  }

  if (!isGlobalEditor) {
    const domContainer = document.querySelector('#editor-projects-recent');
    $('#recent-projects-loader').hide();
    ReactDOM.render(React.createElement(RecentProjects), domContainer);

    if (user.org_pointer.tipo_istanza === 'demo') {
      showContainer('help');
      templateAddHelp();
      initPlayYouTubeModal();
    } else {
      showContainer('projects-recent');
      displayLoadingContainer('projects-recent', 'regular', 12, false);
    }
  } else {
    hideContainer('projects-recent');
  }

  if (isSuperUser && !isGlobalEditor) {
    const domContainer = document.querySelector('#editor-templates-recent');
    $('#recent-templates-loader').hide();
    ReactDOM.render(
      React.createElement(RecentTemplates, {
        orgId: user.org_pointer.objectId,
      }),
      domContainer
    );
    showContainer('templates-recent');
  } else {
    hideContainer('templates-recent');
  }

  showContainer('navigation-breadcrumbs');

  if (!isSelectedProjectType) {
    return enableLoaderInput();
  }

  const requiresFuneral = doesSelectedProjectRequireFuneral();
  window.editorLoader.requiresFuneral = requiresFuneral;
  /**
   * Se la tipologia di progetto e' collegata ad un servizio
   * Faccio selezionare quello
   */
  if (requiresFuneral) {
    const isDefunctCreationEnabled = await isFeatureEnabled(
      FEATURES.CREATE_DEFUNCT
    );
    displayLoadingContainer(
      'servizio',
      'regular',
      isDefunctCreationEnabled ? 2 : 1,
      false
    );
    showContainer('servizio');

    const idServizio = window.urlParams.get('servizio');

    let servizio;
    let isServizioSelected;

    if (idServizio) {
      servizio = await fetchFuneralServiceById(idServizio);
      if (servizio) {
        isServizioSelected = true;
        setServizio(servizio, false);
      }
    }
    if (isServizioSelected) {
      const servizio = getState('selected.servizio');

      const blockServizio = `<div class="${colSizes['regular']} mt-4 block-with-image block-selected"
        data-servizio="true"
        data-toggle="modal"
        data-target="#modalEditorServizio">
        <div class="block-image lazy" data-bg="./assets/blocks/placeholders/servizio.png"></div>
        <div class="block-name h5">${servizio.cognome} ${servizio.nome}</div></div>`;

      $('#editor-servizio').empty();
      $('#editor-servizio').append(blockServizio);
      $('#editor-servizio').append(cambiaServizioBlock);
      if (isDefunctCreationEnabled) {
        $('#editor-servizio').append(aggiungiServizioBlock);
      }
      initNewServizioForm();
      enableLoaderInput();
      window.lazyLoadInstance.update();
    } else {
      // deve scegliere o creare un servizio
      const orgServicesCount = await countFuneralServices();

      $('#editor-servizio').empty();
      if (orgServicesCount > 0) {
        $('#editor-servizio').append(scegliServizioBlock);
      }
      if (isDefunctCreationEnabled) {
        $('#editor-servizio').append(aggiungiServizioBlock);
      }
      hideContainer('formats');
      hideContainer('templates-categories');
      initNewServizioForm();
      enableLoaderInput();
      window.lazyLoadInstance.update();

      return;
    }
  } else {
    enableLoaderInput();
    hideContainer('servizio');
  }

  /**
   * Formats
   */

  showContainer('formats');

  const formats = await fetchProjectFormats(
    getState('selected.tipo'),
    window.editorLoader.forceFetchFormats
  );

  window.editorLoader.forceFetchFormats = false;

  const projectType = getState('selected.tipo');
  const projectId = projectType.objectId;
  window.editorLoader.formats[projectId] = formats;

  /**
   * Se il template e' personalizato faccio vedere tutti i formati
   */
  if (!projectType.isGlobal) {
    const allDefaultFormats = await fetchProjectFormatsDefault();
    projectType.default_formats = allDefaultFormats.formats.items;
  }

  const defautlFormats = projectType.default_formats || [];

  if (!window.editorLoader.defaultFormats[projectId]) {
    window.editorLoader.defaultFormats[projectId] = {};
  }
  window.editorLoader.defaultFormats[projectId][
    window.editorLoader.newFormatOrientation
  ] = { formats: defautlFormats };

  readFormatoFromQueryString(formats);
  await templateAddFormats();

  if (checkShouldCreateCanvas()) {
    await createEditorCanvas();
    return;
  }
};
